export default "__VITE_ASSET__BTqT6m$h__"